<template>
	<div class="container">
		<div class="container-box">
			<div style="display: flex; align-items: center; flex-direction: column">
				<img style="width: 56px; height: 113px" src="../assets/login.png" alt="" />
				<h1 class="login_title">JJLIN客服平台</h1>
			</div>
			<div style="margin-top: 103px; display: flex">
				<div>
					<p style="text-align: right; margin-top: 5px">账号：</p>
					<p style="margin-top: 25px; text-align: right">验证码：</p>
				</div>
				<div>
					<el-input
						v-model="usernamejoker"
						style="width: 300px; margin-left: 15px"
						placeholder="请输入账号"
						maxlength="11"
						@input="checkoutValue"
					/>
					<div class="boxrow">
						<el-input
							placeholder="请输入验证码"
							style="width: 300px; margin-left: 15px"
							maxlength="6"
							v-model="passwordjoker"
							@input="checkoutValue"
						/>
						<el-button
							style="width: 102px; margin-left: 15px"
							:disabled="showText"
							type="primary"
							v-throttle="getcode"
						>
							{{ showText ? downTime + "s后重新获取" : "获取验证码" }}
						</el-button>
					</div>
					<div class="btngroup" v-throttle="handleLogin">
						<p>登入</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { reactive, ref, onMounted, getCurrentInstance } from "vue";
import { post, get } from "../utils/request";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
const { proxy } = getCurrentInstance();
const router = useRouter();
const usernamejoker = ref("");
const passwordjoker = ref("");
const downTime = ref(60);
const showText = ref(false);

const handleLogin = () => {
	if (!usernamejoker.value) {
		ElMessage.error("请输入账号");
		return;
	}
	if (!passwordjoker.value) {
		ElMessage.error("请输入验证码");
		return;
	}

	post(
		`/api-oauth/auth/mobile?mobile=${usernamejoker.value}&smsCode=${passwordjoker.value}`,
		{},
		{
			"Content-Type": "application/json",
			Authorization: "Basic S0VGVV9CQUNLOktFRlVfQkFDS19AMjAyNQ==",
		}
	).then((res) => {
		if (res.code === 1) {
			ElMessage({
				message: "登入成功",
				type: "success",
			});
			sessionStorage.setItem("customer_token", res.result.access_token);
			getuser();
		}
	});
};

const getuser = () => {
	get("/api-oauth/user/info")
		.then((res) => {
			// console.log(res);
			if (res.code == 1) {
				sessionStorage.setItem("nickname", res.result.username);
				sessionStorage.setItem("username", res.result.nickname);
				sessionStorage.setItem("userType", res.result.roles[0].code);
				router.replace("/HistotyRrecord");
			}
		})
		.catch((err) => {});
};
const checkoutValue = () => {
	if (passwordjoker.value) {
		passwordjoker.value = passwordjoker.value.replace(/[^0-9]/g, "");
	}
	if (usernamejoker.value) {
		usernamejoker.value = usernamejoker.value.replace(/[^0-9]/g, "");
	}
};
const getcode = async () => {
	if (!usernamejoker.value) {
		ElMessage.error("请输入账号");
		return;
	}
	if (showText.value) {
		return;
	}
	// sessionStorage.removeItem('customer_token');

	downTime.value = 60;
	showText.value = true;
	const timer = setInterval(() => {
		if (downTime.value > 0) {
			downTime.value--;
		} else {
			if (downTime.value <= 0) {
				clearInterval(timer);
				showText.value = false;
			}
		}
	}, 1000);
	get(`/api-oauth/auth/code/sms?mobile=${usernamejoker.value}`, {}).then((res) => {
		if (res.code === 1) {
			// console.log(res);

			ElMessage({
				message: "验证码已发送",
				type: "success",
			});
		}
	});
};
</script>

<style lang="less" scoped>
.container {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100vh;
	background-color: #ffffff;
}
.input_title {
	width: 20%;
	font-size: 14px;
	text-align: right;
	color: #000000;
}
.container-box {
	margin-top: -120px;
	.boxrow {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 15px;
	}
	.btngroup {
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 298px;
		height: 32px;
		background: #9d58ff;
		border-radius: 4px;
		margin-left: 15px;
		cursor: pointer;
		p {
			font-size: 14px;
			color: #ffffff;
		}
		&:hover {
			background: rgba(161, 91, 255, 0.2);
			p {
				color: #9d58ff;
			}
		}
	}
}
.code {
	width: 102px;
	height: 32px;
	background: #9d58ff;
	border-radius: 4px;
	text-align: center;
	line-height: 32px;
	font-size: 14px;
	color: #ffffff;
	margin-left: 15px;
	cursor: pointer;
}
.login_title {
	font-weight: 500;
	font-size: 20px;
	color: #9d58ff;
	line-height: 22px;
}
</style>
